import { apiFetch } from './client';

export const automationAPI = {
  setup: (setupData) =>
      apiFetch('/automation/setup', {
        method: 'POST',
        body: JSON.stringify(setupData),
      }),

  getStatus: (accountId) =>
      apiFetch(`/automation/status/${accountId}`),
};

export const generationRuleAPI = {
  get: (accountId) =>
      apiFetch(`/generation-rules/account/${accountId}`),

  save: (accountId, data) =>
      apiFetch(`/generation-rules/account/${accountId}`, {
        method: 'POST',
        body: JSON.stringify(data),
      }),

  execute: (ruleId) =>
      apiFetch(`/generation-rules/${ruleId}/execute`, { method: 'POST' }),

  resetStatus: (ruleId) =>
      apiFetch(`/generation-rules/${ruleId}/reset-status`, { method: 'PATCH' }),
};

export const scheduleAPI = {
  getConfig: () => apiFetch('/schedule'),

  updateConfig: (config) =>
      apiFetch('/schedule', {
        method: 'POST',
        body: JSON.stringify(config),
      }),
};
